<template>
  <footer>
    <div class="container">
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped lang="scss">
@import '../../styles/Variables.scss';

  footer {
    background: $grandaddy-purp;
    height: 3.5rem;
    width: 100%;
  }
</style>
